import { render, staticRenderFns } from "./ShareInvoiceModal.vue?vue&type=template&id=3537cf40"
import script from "./ShareInvoiceModal.vue?vue&type=script&lang=js"
export * from "./ShareInvoiceModal.vue?vue&type=script&lang=js"
import style0 from "./ShareInvoiceModal.vue?vue&type=style&index=0&id=3537cf40&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports